"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatType = void 0;
/**
 *Enum used to define a specific Price Format display format.
 */
var PriceFormatType;
(function (PriceFormatType) {
    /**
     * Displays price with 3 letter ISO 4217 currency code.
     *
     * Example: USD1,234.56
     */
    PriceFormatType["ISO"] = "iso";
    /**
     * Display price using currency long name.
     *
     * Example: 1,234.56 US Dollars
     */
    PriceFormatType["PLURAL"] = "plural";
    /**
     * Display price using Amazon specific custom symbol(wherever applicable).
     * If no custom symbol is defined then CLDR default formatting will be applied.
     *
     * Example: CDN$1,234.56
     */
    PriceFormatType["AMAZON_SYMBOL"] = "amazonSymbol";
    /**
     * Display price without decimal places and spaces.
     *
     * Example: $1234
     */
    PriceFormatType["COMPACT"] = "compact";
    /**
     * Display price used within sentences.
     *
     * Example: $1,000,000
     */
    PriceFormatType["IN_SENTENCE"] = "inSentence";
})(PriceFormatType = exports.PriceFormatType || (exports.PriceFormatType = {}));
//# sourceMappingURL=price-format-type.enum.js.map